
    var mustache = require('mustache');
    module.exports = function (view, partials) {
      partials = partials || {};
      var src = "{{#showSyncSuggestion}}\n  <div class=\"info\" id=\"suggest-sync\">\n      {{#unsafeTranslate}}Looking for Firefox Sync? <a %(escapedSyncSuggestionAttrs)s>Get started here</a>{{/unsafeTranslate}}\n      <span class=\"dismiss\" tabindex=\"-1\">&#10005;</span>\n  </div>\n{{/showSyncSuggestion}}\n"
      return mustache.render(src, view, partials);
    };
  